module.exports = __webpack_public_path__ + "static/img/ruanjian.7f312c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ruanjian.jpg
// module id = VYTX
// module chunks = 1